import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private auth: AuthService) {
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // return next.handle(req).pipe(tap((event: any) => {
        //     if (event instanceof HttpErrorResponse) {
        //         this.auth.loader$.next(false);
        //     }
        // }))

        return next.handle(req).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    this.auth.loader$.next(false);
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                this.auth.loader$.next(false);
                return throwError(error);
            }));
    }
}
